export default __webpack_public_path__ + "static/media/ossscreen1.f97fe7a8.png";